module.exports = __webpack_public_path__ + "static/media/ios-icon.d7d9172f.png";